<!-- Forced rebuild v2 -->
<template>
  <div class="min-h-screen bg-white">
    <!-- Logo Section -->
    <section class="border-b border-slate-100">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div class="flex justify-center">
          <img src="/teamio_new_logo_trans_1.png" alt="Teamio" class="h-24 w-auto" />
        </div>
      </div>
    </section>

    <!-- Hero Section -->
    <section class="relative">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <h1 class="text-4xl md:text-6xl font-semibold tracking-tight text-slate-900 text-center">
          Coming Soon!
        </h1>
        <p class="mt-6 text-lg md:text-xl text-slate-600 text-center max-w-3xl mx-auto">
          Teamio is currently under development. We're creating the UK's premier platform for connecting junior football players with teams and coaches across all levels. Stay tuned for our official launch!
        </p>
        <div class="mt-2 flex justify-center">
          <span class="h-1 w-28 rounded-full bg-gradient-to-r from-[#5C2A6D] to-[#2A3B6D]"></span>
        </div>
        <!-- TEAMIO Text Logo - NO PADDING -->
        <div class="flex justify-center">
          <img src="/teamio_logo_640x360_transparent.png" alt="TEAMIO" class="h-60 md:h-80 w-auto" />
        </div>
      </div>
    </section>

    <!-- Features Preview -->
    <section class="border-t border-slate-100">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div class="rounded-2xl bg-slate-50 p-8">
            <div class="w-12 h-12 bg-gradient-to-br from-[#5C2A6D] to-[#2A3B6D] rounded-xl flex items-center justify-center mb-4">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-slate-900 mb-2">Connect Players & Teams</h3>
            <p class="text-slate-600">Whether you're a player seeking a new challenge or a coach seeking talent, Teamio offers a streamlined way to connect and collaborate.</p>
          </div>

          <div class="rounded-2xl bg-slate-50 p-8">
            <div class="w-12 h-12 bg-gradient-to-br from-[#5C2A6D] to-[#2A3B6D] rounded-xl flex items-center justify-center mb-4">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-slate-900 mb-2">Transparent Communication</h3>
            <p class="text-slate-600">Making grassroots football more accessible and transparent for players, parents, coaches, and clubs alike.</p>
          </div>

          <div class="rounded-2xl bg-slate-50 p-8">
            <div class="w-12 h-12 bg-gradient-to-br from-[#5C2A6D] to-[#2A3B6D] rounded-xl flex items-center justify-center mb-4">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-slate-900 mb-2">Player Development</h3>
            <p class="text-slate-600">Giving every junior player the opportunity to develop and find the right environment to thrive across all levels.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Get Updates Section with Mailchimp Form -->
    <section class="border-t border-slate-100">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div class="max-w-md mx-auto">
          <h2 class="text-3xl md:text-4xl font-semibold text-slate-900 text-center mb-4">Get Updates</h2>
          <p class="text-lg text-slate-600 text-center mb-8">
            Want to be notified when we launch? Sign up for early access information.
          </p>
          
          <!-- Mailchimp Form -->
          <div id="mc_embed_signup" class="mailchimp-form">
            <form action="https://hotmail.us15.list-manage.com/subscribe/post?u=03ec77b3936d6c00ae90518ad&amp;id=3885d722b6&amp;f_id=0083c2e1f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank">
              <div id="mc_embed_signup_scroll">
                <div class="mc-field-group mb-4">
                  <label for="mce-EMAIL" class="block text-sm font-medium text-slate-700 mb-2">
                    Email Address <span class="text-red-500">*</span>
                  </label>
                  <input 
                    type="email" 
                    name="EMAIL" 
                    class="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#5C2A6D] focus:border-transparent outline-none transition" 
                    id="mce-EMAIL" 
                    required 
                    value=""
                    placeholder="your@email.com"
                  >
                </div>
                
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div class="mc-field-group">
                    <label for="mce-FNAME" class="block text-sm font-medium text-slate-700 mb-2">First Name</label>
                    <input 
                      type="text" 
                      name="FNAME" 
                      class="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#5C2A6D] focus:border-transparent outline-none transition" 
                      id="mce-FNAME" 
                      value=""
                      placeholder="John"
                    >
                  </div>
                  
                  <div class="mc-field-group">
                    <label for="mce-LNAME" class="block text-sm font-medium text-slate-700 mb-2">Last Name</label>
                    <input 
                      type="text" 
                      name="LNAME" 
                      class="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#5C2A6D] focus:border-transparent outline-none transition" 
                      id="mce-LNAME" 
                      value=""
                      placeholder="Smith"
                    >
                  </div>
                </div>
                
                <div class="mc-field-group mb-6">
                  <label for="mce-MMERGE7" class="block text-sm font-medium text-slate-700 mb-2">I am a</label>
                  <select 
                    name="MMERGE7" 
                    class="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#5C2A6D] focus:border-transparent outline-none transition bg-white" 
                    id="mce-MMERGE7"
                  >
                    <option value="">Select...</option>
                    <option value="Coach">Coach</option>
                    <option value="Parent">Parent</option>
                  </select>
                </div>
                
                <div id="mce-responses" class="clear foot">
                  <div class="response text-red-600 text-sm mb-2" id="mce-error-response" style="display: none;"></div>
                  <div class="response text-green-600 text-sm mb-2" id="mce-success-response" style="display: none;"></div>
                </div>
                
                <!-- Bot prevention -->
                <div style="position: absolute; left: -5000px;" aria-hidden="true">
                  <input type="text" name="b_03ec77b3936d6c00ae90518ad_3885d722b6" tabindex="-1" value="">
                </div>
                
                <div class="clear foot">
                  <input 
                    type="submit" 
                    name="subscribe" 
                    id="mc-embedded-subscribe" 
                    class="w-full px-6 py-3 rounded-full text-white bg-gradient-to-r from-[#5C2A6D] to-[#2A3B6D] hover:opacity-95 transition font-medium cursor-pointer" 
                    value="Subscribe"
                  >
                </div>
              </div>
            </form>
          </div>
          
          <p class="mt-8 text-center">
            <a href="mailto:info@teamio.co.uk" class="text-slate-600 hover:text-slate-900 transition text-sm">
              Or contact us directly
            </a>
          </p>
        </div>
        
        <p class="mt-12 text-sm text-slate-500 text-center">
          &copy; {{ currentYear }} Teamio. All rights reserved.
        </p>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'

const currentYear = computed(() => new Date().getFullYear())

// Load Mailchimp validation script
onMounted(() => {
  const script = document.createElement('script')
  script.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'
  script.type = 'text/javascript'
  document.body.appendChild(script)
  
  script.onload = () => {
    const initScript = document.createElement('script')
    initScript.type = 'text/javascript'
    initScript.text = `
      (function($) {
        window.fnames = new Array(); 
        window.ftypes = new Array();
        fnames[0]='EMAIL';ftypes[0]='email';
        fnames[1]='FNAME';ftypes[1]='text';
        fnames[2]='LNAME';ftypes[2]='text';
        fnames[7]='MMERGE7';ftypes[7]='dropdown';
      }(jQuery));
      var $mcj = jQuery.noConflict(true);
    `
    document.body.appendChild(initScript)
  }
})
</script>

<style scoped>
/* Additional styles to ensure Mailchimp form matches the page design */
.mailchimp-form {
  font-family: inherit;
}

.mailchimp-form input:focus,
.mailchimp-form select:focus {
  box-shadow: 0 0 0 3px rgba(92, 42, 109, 0.1);
}
</style>
